import { Menu, MenuItem, MenuProps, styled } from '@mui/material';
import { SubMenuItem } from '@src/main/ui/components/layout/common/Navbar/common/hooks/useNavbarItems';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './DrawerMenu.module.scss';

interface DrawerMenuProps {
  anchorEl: HTMLElement | null;
  close: () => void;
  onMenuEnter: () => void;
  menuItems: SubMenuItem[];
}

const StyledMenu = styled((props: MenuProps) => <Menu {...props} />)(() => ({
  '& .MuiPaper-root': {
    minWidth: 200,
  },
}));

const DrawerMenu: FC<DrawerMenuProps> = ({ anchorEl, close, onMenuEnter, menuItems }) => (
  <StyledMenu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={close}
    elevation={3}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    MenuListProps={{ onMouseLeave: close, onMouseEnter: onMenuEnter }}
  >
    {menuItems.map((menuItem) => (
      <Link key={menuItem.text} to={menuItem.url}>
        <MenuItem
          key={menuItem.text}
          onClick={() => {
            close();
          }}
        >
          <div className={styles.drawerMenu__menuItem}>
            <span>{menuItem.text}</span>
          </div>
        </MenuItem>
      </Link>
    ))}
  </StyledMenu>
);

export default DrawerMenu;
